import { useMutation } from "react-query";
import { editSingleDoorBuzzer } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSingleDoorBuzzer = () => {
  return useMutation(editSingleDoorBuzzer);
};
export default useEditSingleDoorBuzzer;
